import { Button, Space, Table, notification, Tooltip } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import ModalCreated from "./components/ModalCreated";
import { getUser } from "utils/index";
import { HomeOutlined, EditOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import userApi from "api/user";
import ModalChangePassword from "./components/ModalChangePassword";
import { rolesAction, rolesAddShop } from "./roles";

const cx = classNames.bind(style);

export default function Shops() {
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataShop, setDataShop] = useState();
  const [shops, setShops] = useState([]);

  const getShopManager = async () => {
    try {
      setLoading(true)
      const res = await userApi.getAllShopManager();
      setShops(res.users.filter(item => item.shops.length > 0).sort((a, b) => a.shops[0].shop.shop_code - b.shops[0].shop.shop_code));
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  // const onConfirm = async (id) => {
  //   await shopApi.deleteShop(id);
  //   openNotificationWithIcon("success", "Thông báo", "Xóa cửa hàng thành công !")
  //   getStore();
  // };

  const columns = [
    {
      title: t('shopCode'),
      dataIndex: "shopCode",
      key: "shopCode",
      render: (_, record) => record?.shops?.[0]?.shop?.shop_code
    },
    {
      title: t('shopName'),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t('userName'),
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: t('action'),
      dataIndex: "action",
      key: "aciton",
      render: (text, row) => {
        return (
          <Space>
            {rolesAction.includes(+getUser().role) && (
              <>
                <Button
                  title={t('edit')}
                  onClick={() => {
                    setOpenModal(true);
                    setDataShop(row);
                  }}
                >
                  <Tooltip title={t('edit')}>
                    <EditOutlined />
                  </Tooltip>

                </Button>
                <ModalChangePassword
                  id={row._id}
                  openNotificationWithIcon={openNotificationWithIcon}
                />
              </>
            )}
            {/* <Popconfirm
              title="Bạn chắc chắn muốn xóa cửa hàng ?"
              description=""
              onConfirm={() => onConfirm(row._id)}
            >
              <Button danger>Xóa</Button>
            </Popconfirm> */}
          </Space>
        );
      },
    },
  ];

  useEffect(() => {
    getShopManager()
  }, []);

  return (
    <div className={cx("page-shop")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('listShop')}</p>
        {rolesAddShop.includes(+getUser().role) && (
          <Button onClick={() => setOpenModal(true)}><Tooltip title={t('addShop')}>
            <HomeOutlined />
          </Tooltip></Button>
        )}
      </div>
      <Table loading={loading} columns={columns} dataSource={shops} bordered />
      <ModalCreated
        openNotificationWithIcon={openNotificationWithIcon}
        setOpenModal={setOpenModal}
        setDataShop={setDataShop}
        dataShop={dataShop}
        openModal={openModal}
        getStore={getShopManager}
      />
    </div>
  );
}
